import { Directive, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[appDelayedMouseleave]',
  standalone: true,
})
export class DelayedMouseleaveDirective implements OnDestroy {
  @Input() delayedMouseleaveMs = 300;
  @Output() appDelayedMouseleave = new EventEmitter<void>();

  private closeTimeoutId?: ReturnType<typeof setTimeout>;

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.cancelScheduledClose();
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.cancelScheduledClose();
    this.closeTimeoutId = setTimeout(() => {
      this.appDelayedMouseleave.emit();
      this.closeTimeoutId = undefined;
    }, this.delayedMouseleaveMs);
  }

  ngOnDestroy(): void {
    this.cancelScheduledClose();
  }

  cancelScheduledClose(): void {
    if (this.closeTimeoutId !== undefined) {
      clearTimeout(this.closeTimeoutId);
      this.closeTimeoutId = undefined;
    }
  }
}
